import { Site } from '@envato/foundation-types'
import isEmpty from 'lodash-es/isEmpty'
import get from 'lodash-es/get'

import { IExperimentsConfig } from '../../config/experiments'
import { getConfigBySite } from '../../config/sites'
import { ICommonLocation } from './location/types'

export const isExperimentRunning = ({
  experimentsConfig,
  experimentName,
  currentSite,
  location
}: {
  experimentsConfig: IExperimentsConfig
  experimentName: string
  currentSite: Site
  location: ICommonLocation
}) => {
  const experiment = experimentsConfig[experimentName]

  if (!experiment) {
    return false
  }

  const isRunning =
    experiment.running ||
    get(location, 'query.experiment', '') === experimentName
  const isForCurrentSite =
    experiment.sites.includes(currentSite) || isEmpty(experiment.sites)

  const isRunningForCurrentSite = isRunning && isForCurrentSite

  return isRunningForCurrentSite
}

export const shouldDisplayLoadingCover = ({
  experimentsReady,
  experimentsConfig,
  currentSite
}: {
  experimentsReady: boolean
  experimentsConfig: IExperimentsConfig
  currentSite: Site
}) => {
  const isCoverEnabledBySiteConfig = getConfigBySite(
    currentSite,
    'experimentsLoadingCover'
  )
  const isCoverEnabledByExperimentsConfig = Object.keys(experimentsConfig)
    .map(key => experimentsConfig[key])
    .some(
      expConfig =>
        expConfig.sites.includes(currentSite) && !!expConfig.loadingCover
    )

  return (
    (isCoverEnabledByExperimentsConfig || isCoverEnabledBySiteConfig) &&
    !experimentsReady
  )
}
